export enum RouteDocumentTypes {
    DeliveryNote = "DeliveryNote",
    CMR = "CMR",
    Other = "Other",
    LoadTest = "LoadTest",
    UnloadTest = "UnloadTest",
    TripIncident = "TripIncident",
    None = "None"
}
